export enum MainRoutes {
  AppSignUrls = 'app-sign-urls',
  Check = 'check',
  ConvertCsvToJson = 'convert-csv-to-json',
  ConvertJsonToCsv = 'convert-json-to-csv',
  Error = 'error',
  LocalSignUrls = 'local-sign-urls',
  Order = 'order',
  Ping = 'ping',
  RestartCron = 'restart-cron',
  Slack = 'slack',
}
